











import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import { mapState as mapRootState } from 'vuex';
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    props: {
        refNo: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapCustomLabelsState(['grievanceRefNo']),
        ...mapRootState(['portalBranding']),
    },
});
